import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');


let Service = {

  /**
   * Promise request
   * @param {String} url
   *        请求地址
   *
   * @param {Object} opts
   *        请求参数
   *
   * @retur Promise
   */
  reqPromise(url, opts) {

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        params: Util.removeFalseKeyInObject(opts)
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '0001') {

          reject(new Error(`${url}接口参数错误`));
        } else if (data.body.code === '1') {

          // 没有数据
          resolve([]);
        } else {

          reject(new Error(`${url}接口错误`));
        }
      }, data => {

        reject(new Error(data));
      });
    });
  },

  /**
   * 查询 服务站icon菜单展示
   *
   * @param {Number | String} cityCode 城市编码
   *
   * @return Promise
   */
  queryIconMenu(cityCode) {

    let url = CONF.API.stationIcon,
      jsonpCallback = 'iconMenuCallback';

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', jsonpCallback);

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        jsonpCallback: jsonpCallback
      }).then(data => {
        if (data.body.code === '0') {
          resolve(data.body.data);
        } else if (data.body.code === '0001') {
          reject(new Error(`${url}接口参数错误`));
        } else if (data.body.code === '1') {
          // 没有数据
          resolve([]);
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },

  /**
   * 查询特定业务类型下的分类菜单
   *
   * @params {String} type
   *         1035 v购视频品类（如：手机 | 电脑 | 冰箱...）
   *         1036 门店类型 （如：苏宁小店 | 红孩子母婴...）
   *         1037 身边苏宁活动类型 （如： 促销活动 | 校园活动 | 金融活动...）
   *         1038 通用业务类型 （如：手机维修 | 理财顾问...）
   *         1044 电器店商品分类
   *
   * @return Promise
   */
  queryParameter(type) {

    let url = CONF.API.parameterUrl;

    url = url
      .replace('{{parentParameterId}}', type)
      .replace('{{callback}}', 'queryParameterCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {

        jsonpCallback: 'queryParameterCallback'
      }).then(data => {
        if (data.body.code === '0') {

          resolve(data.body.data);
        } else if (data.body.code === '0005') {

          resolve([]);

        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },

  /**
   * 查询城市下的商圈
   *
   * @params {String} cityCode
   *
   * @return Promise
   */
  queryTradingArea(cityCode) {

    let url = CONF.API.tradingAreaUrl;

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', 'queryTradingAreaCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: 'queryTradingAreaCallback'
      }).then(data => {
        if (data.body.code === '0' || data.body.code === '0005' ) {

          resolve(data.body);
        } else {
          reject(new Error(`${url}接口错误`));
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },

  /**
   * 查区域
   * @param: {String} cityCode
   * @return Promise
   */
  queryDistrictByCityCode(cityCode) {

    let url = CONF.API.queryDistrictList;

    url = url
      .replace('{{cityCode}}', cityCode)
      .replace('{{callback}}', 'queryDistrictCallback');

    return new Promise((resolve, reject) => {
      Vue.http.jsonp(url, {
        jsonpCallback: 'queryDistrictCallback'
      }).then(data => {

        if (data.body.districts.length > 0) {

          resolve(data.body.districts);
        } else {
          resolve([]);
        }
      }, data => {
        reject(new Error(data));
      });
    });
  },

  /**
   * 评价页面 公用
   * @param: {String} storeCode
   * @param: {Number} pageNumber
   * @return Promise
   */
  queryEvaluate(storeCode, pageNumber) {

    let _this = this;

    let url = CONF.API.queryEvaluate;

    return new Promise((resolve, reject) => {
      _this.reqPromise(url, {
        storeCode,
        pageNumber
      }).then(data => {
        resolve(data);
      });
    });
  }
};
export default Service;



// WEBPACK FOOTER //
// ./src/services/CommonServer.js